import { X as CloseIcon } from "@untitledui/icons";
import { forwardRef } from "react";
import {
	Button as AriaButton,
	type ButtonProps as AriaButtonProps,
} from "react-aria-components";

import { cx } from "@/utils/cx";

const sizes = {
	lg: { icon: "size-6", root: "size-11" },
	md: { icon: "size-5", root: "size-10" },
	sm: { icon: "size-5", root: "size-9" },
	xs: { icon: "size-4", root: "size-7" },
};

const themes = {
	dark: "text-fg-white/70 hover:text-fg-white hover:bg-white/20 focus-visible:outline-2 focus-visible:outline-offset-2 outline-focus-ring",
	light:
		"text-fg-quaternary hover:bg-primary_hover hover:text-fg-quaternary_hover focus-visible:outline-2 focus-visible:outline-offset-2 outline-focus-ring",
};

interface CloseButtonProps extends AriaButtonProps {
	label?: string;
	size?: "lg" | "md" | "sm" | "xs";
	theme?: "dark" | "light";
}

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
	(
		{
			className,
			label,
			size = "sm",
			theme = "light",
			type = "button",
			...otherProps
		},
		forwardedRef,
	) => {
		return (
			<AriaButton
				{...otherProps}
				aria-label={label || "Close"}
				className={(state) =>
					cx(
						"flex cursor-pointer items-center justify-center rounded-lg p-2 transition duration-100 ease-linear focus:outline-hidden",
						sizes[size].root,
						themes[theme],
						typeof className === "function" ? className(state) : className,
					)
				}
				ref={forwardedRef}
				type={type}
			>
				<CloseIcon
					aria-hidden="true"
					className={cx("shrink-0 transition-inherit-all", sizes[size].icon)}
				/>
			</AriaButton>
		);
	},
);

CloseButton.displayName = "CloseButton";
